import {AddSchema} from "mobx-graphlink";
import {AutoEndType} from "../@EngineConfig.js";
import {Setting} from "./@Shared/Setting.js";
import {EffectPointer, SoundMutingType, SoundPanningType} from "../../@Shared/EffectPointer.js";

export class EngineConfig_General {
	constructor(initialData: Partial<EngineConfig_General>) { Object.assign(this, initialData); }

	initialDelay: number; // in ms
	autoEnd_enabled: boolean;
	autoEnd_type: AutoEndType;
	autoEnd_time: number; // target time (regular format: ms since epoch)
	autoEnd_delay: number; // in ms
	sleepBlockers_enabled: boolean;
	startupScriptTag?: string|n;
	resetScreenLightTag?: string|n;
	defaultVoice_soundTag: string;
	defaultVoice_volumeMultiplier: number;
	globalVolumeMultiplier: Setting<number>;
	globalPanningTypeFallback: SoundPanningType;
	globalMutingTypeFallback: SoundMutingType;
	globalAlarmRestartIntervalMultiplier: Setting<number>;
	mouseMove_minDistToTrigger: number;
	mouseMove_compareWindow: number;
	mouseMoveRepeatReject_enabled: boolean;
	mouseMoveRepeatReject_roundPositionsTo: number;
	//mouseMoveRepeatReject_cyclingResetTime: number;
	sessionUI_hideStatusBar: boolean;
	sessionUI_hideNavBar: boolean;
	lockOverlay_hideStatusBar: boolean;
	lockOverlay_hideNavBar: boolean;
	sessionCrashCheck_enabled: boolean;
	sessionCrashCheck_interval: number; // in minutes
	notes: string;
}
AddSchema("EngineConfig_General", {
	properties: {
		initialDelay: {type: "number"},
		autoEnd_enabled: {type: "boolean"},
		autoEnd_type: {$ref: "AutoEndType"},
		autoEnd_time: {type: "number"},
		autoEnd_delay: {type: "number"},
		sleepBlockers_enabled: {type: "boolean"},
		startupScriptTag: {type: ["null", "string"]},
		resetScreenLightTag: {type: ["null", "string"]},
		defaultVoice_soundTag: {type: "string"},
		defaultVoice_volumeMultiplier: {type: "number"},
		globalVolumeMultiplier: {$ref: "Setting"},
		globalPanningTypeFallback: {$ref: "SoundPanningType"},
		globalMutingTypeFallback: {$ref: "SoundMutingType"},
		globalAlarmRestartIntervalMultiplier: {$ref: "Setting"},
		mouseMove_minDistToTrigger: {type: "number"},
		mouseMove_compareWindow: {type: "number"},
		mouseMoveRepeatReject_enabled: {type: "boolean"},
		mouseMoveRepeatReject_roundPositionsTo: {type: "number"},
		sessionUI_hideStatusBar: {type: "boolean"},
		sessionUI_hideNavBar: {type: "boolean"},
		lockOverlay_hideStatusBar: {type: "boolean"},
		lockOverlay_hideNavBar: {type: "boolean"},
		sessionCrashCheck_enabled: {type: "boolean"},
		sessionCrashCheck_interval: {type: "number"},
		notes: {type: "string"},
	},
});